export default __webpack_public_path__ + "static/MartianMono-SemiBold-4455e63960e60b3ef882042dd15f6794.ttf";